import { gql } from '@apollo/client';

export const SEND_CAMPAIGN_MESSAGE = gql`
  mutation SendCampaignMessage($input: SendCampaignMessageInput!) {
    sendCampaignMessage(input: $input) {
      id
      message
      attachmentUrl
      createdDate
      messageRead
      readDate
      campaignId
      senderId
      senderUserName
      senderType
      senderTypeNavigation {
        id
        typeName
      }
      messageTypeId
      messageType {
        id
        typeName
      }
    }
  }
`;

export const MARK_MESSAGES_AS_READ = gql`
  mutation MarkCampaignMessagesAsRead($messageIds: [Int!]!) {
    markCampaignMessagesAsRead(messageIds: $messageIds)
  }
`;

